const MAPBOX_BLOCKED_CRAWLER_RE = /(yisouspider|baiduspider|bingbot|googlebot|bytespider|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|duckduckbot|applebot|yandexbot|facebookexternalhit|twitterbot|crawler|spider|slurp|robot|bot)/i;

export default function isMapboxBlockedCrawler(userAgent = '') {
  return MAPBOX_BLOCKED_CRAWLER_RE.test(String(userAgent || ''));
}
